<template>
<v-card :class="{'my-3':true,'mx-3':$vuetify.breakpoint.smAndUp}" outlined>
    <v-card-title>
        <v-row no-gutters align="center">
            {{room.name}}
            <v-spacer />
            <div>
                <v-btn depressed color="primary" :small="$vuetify.breakpoint.smAndDown" class="ma-1" @click="$emit('openDialogInventory')">{{ $t('sheet.inventory') }}</v-btn>
                <v-btn depressed color="primary" :small="$vuetify.breakpoint.smAndDown" class="ma-1" @click="$emit('openDialogPricing')">{{ $t('sheet.pricing') }}</v-btn>
            </div>
        </v-row>
    </v-card-title>
    <v-divider class="mx-4" />
    <v-card-text class="sheet-wrapper" ref="sheet-wrapper" @scroll="$emit('scroll', room)" @mouseover="$emit('select', room)">

        <table class="sheet sheet-highlight">

            <colgroup>
                <col />
                <col v-for="(day, index) in days" :key="'day' + index" :class="column_class(day)" />
            </colgroup>

            <thead>
                <tr class="white">
                    <th></th>
                    <th v-for="(day, index) in days" :key="'month' + index" class="sheet-date text-capitalize pa-1" :style="{ backgroundColor: !month(day) ? 'transparent' : 'white'}">
                        {{ month(day) }}
                    </th>
                </tr>
                <tr>
                    <th class="sheet-header text-center" style="border-top: 1px solid white; border-left: 1px solid white;"></th>
                    <th v-for="(day, index) in days" :key="index" class="sheet-cell" style="border-top: 2px solid rgba(0, 0, 0, .1);">
                        {{ $moment(day).locale($vuetify.lang.current).format('ddd') }} {{ $moment(day).format('D') }}
                    </th>
                </tr>
            </thead>

            <tbody>
                <room-close-inventory :inventory="sheet.inventory[room.id]" :params="params" :backup_sheet="backup_sheet"></room-close-inventory>
                <room-inventory :inventory="sheet.inventory[room.id]" :params="params" :backup_sheet="backup_sheet"></room-inventory>
                <room-booked :inventory="sheet.inventory[room.id]"></room-booked>
            </tbody>

            <template v-for="rate in room.rate_plans">
                <template v-if="!rate.stop_sell&&selected_rate_plans.includes(rate.id)&&(net_price==rate.net_prices)">
                    <rate-plan :rate_plan="rate" :prices="sheet.pricing[room.id][rate.id]" :net_price="net_price" :context="context" :weekend="weekend" :admin="admin" :params="params" :backup_sheet="backup_sheet" />
                </template>
            </template>

        </table>

    </v-card-text>

</v-card>
</template>

<script>
import {
    mapActions
} from 'vuex';
import InventoryModal from './InventoryModal.vue';
import PricingModal from './PricingModal.vue';
import RoomInventory from './SheetRows/RoomInventory.vue';
import RoomBooked from './SheetRows/RoomBooked.vue';
import RoomCloseInventory from './SheetRows/RoomCloseInventory.vue';
import RatePlan from './SheetRows/RatePlan.vue';

export default {
    components: {
        "im-inventory-modal": InventoryModal,
        "im-pricing-modal": PricingModal,
        "room-inventory": RoomInventory,
        "room-booked": RoomBooked,
        "room-close-inventory": RoomCloseInventory,
        "rate-plan": RatePlan,
    },
    name: `sheet`,

    props: {
        room: [Array, Object],
        days: [Array, Object],
        sheet: [Object, Array],
        backup_sheet: [Object, Array],
        params: Object,
        selected_rooms: Array,
        selected_rate_plans: Array,
        net_price: Boolean,
        admin: Boolean,
        master_leo: Boolean,
        context: String,
        weekend: Array,

    },
    data() {
        return {
            rooms_restictions: [],
        }
    },

    methods: {
        ...mapActions('alert', ['success', 'error']),

        column_class: function (day) {

            return {
                weekday: true,
                weekend: this.weekend.map(Number)
                    .includes(this.$moment(day)
                        .weekday())
            }
        },

        month: function (day) {
            let month_start = this.$moment(day)
                .startOf('day');
            if(month_start.format('YYYY-MM-DD') === this.days[0]) return this.$moment(month_start)
                .locale(this.$vuetify.lang.current)
                .format('MMM YYYY');
            if(month_start.format('YYYY-MM-DD') === month_start.clone()
                .startOf('month')
                .format('YYYY-MM-DD')) return this.$moment(month_start)
                .locale(this.$vuetify.lang.current)
                .format('MMM YYYY');
            return null;
        },

    },
}
</script>
<style >
.sheet-wrapper {
    overflow-x: auto;
    overflow-y: hidden;
    padding: 0 !important;
}

/* .sheet-wrapper::-webkit-scrollbar {
    height: 10px;
}

.sheet-wrapper::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #808080;
    border-radius: 5px;
}

.sheet-wrapper::-webkit-scrollbar-thumb {
    background: #808080;
    border-radius: 5px;
}

.sheet-wrapper::-webkit-scrollbar-thumb:hover {
    background: #808080;
} */

.sheet {
    border-spacing: 0;
}

.sheet thead th {
    top: 0;
    position: -webkit-sticky;
    position: sticky;
}

.sheet thead th:first-child {
    left: 0;
    z-index: 1;
}

.sheet tbody th {
    left: 0;
    position: -webkit-sticky;
    position: sticky;
}

.sheet tbody tr:hover {
    background-color: rgba(0, 0, 0, 0.05);
}

.sheet-date {
    left: 275px;
    position: -webkit-sticky;
    position: sticky;
    font-size: 12px;
}

.sheet-header {
    font-size: 12px;
    text-align: left;
    width: 275px;
    min-width: 275px;
    max-width: 275px;
    background-color: white;
    z-index: 1;
    border: 1px solid rgba(0, 0, 0, .1);
    padding: 4px;
}

.sheet-cell {
    min-width: 80px;
    max-width: 100px;
    padding: 4px;
    border: 1px solid rgba(0, 0, 0, .1);
}

@media screen and (max-width: 600px) {
    .sheet-header {
        width: 190px;
        min-width: 190px;
        max-width: 190px;
    }
}

.sheet-input {
    width: 100%;
    height: 24px;
    background-color: white;
    font-size: 12px;
    text-align: center;
    outline: 1px solid rgba(0, 0, 0, .1);
}

.sheet-input-left {
    width: calc(50% - 2px);
    margin-right: 2px;
    height: 24px;
    background-color: white;
    font-size: 12px;
    text-align: center;
    outline: 1px solid rgba(0, 0, 0, .1);
}

.sheet-input-right {
    width: calc(50% - 2px);
    margin-left: 2px;
    height: 24px;
    background-color: white;
    font-size: 12px;
    text-align: center;
    outline: 1px solid rgba(0, 0, 0, .1);
}

.sheet-switch-left {
    padding: 0 !important;
    margin: 0 2px 0 0 !important;
    min-width: 0 !important;
    width: calc(50% - 2px);
}

.sheet-switch-right {
    padding: 0 !important;
    margin: 0 0 0 2px !important;
    min-width: 0 !important;
    width: calc(50% - 2px);
}

.weekday {
    background-color: rgba(0, 0, 0, .025);
}

.weekend {
    background-color: rgba(0, 0, 0, .075);
}
</style>
